export default __webpack_public_path__ + "static/media/process.8300e78e.png";